module.exports = __webpack_public_path__ + "static/media/rocket.3ab6811d.gif";